let methods = {
  one: {},
  two: {},
  three: {},
  four: {},
}

let model = {
  one: {},
  two: {},
  three: {},
}
let compute = {}
let hooks = []

export default { methods, model, compute, hooks }
